import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { fetchContacts } from '../../../redux/ducks/contacts';

import ContactsPage from './ContactsPage';
import NewContactPage from './NewContactPage';
import EditContactPage from './EditContactPage';
import ViewContactPage from './ViewContactPage';
import Loading from '../../common/Loading';

class ContactsRootPage extends React.Component {
  componentDidMount() {
    const { fetched, getContacts } = this.props;

    if (!fetched) {
      getContacts();
    }
  }

  render() {
    const { isFetching, fetched } = this.props;

    if (isFetching || !fetched) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route path="/contacts/new/:returnPath?" component={NewContactPage} />
        <Route path="/contacts/:id/edit" component={EditContactPage} />
        <Route path="/contacts/:id" component={ViewContactPage} />
        <Route path="/contacts" component={ContactsPage} />
      </Switch>
    );
  }
}

ContactsRootPage.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  fetched: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Date)]).isRequired,
  getContacts: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const {
    contacts: { isFetching, fetched },
  } = state;

  return {
    isFetching,
    fetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getContacts: () => {
      dispatch(fetchContacts());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactsRootPage);



// WEBPACK FOOTER //
// ./src/components/pages/contacts/ContactsRootPage.jsx